module.exports = __webpack_public_path__ + "static/media/user_funnel_analysis.fed79eaa.png";